import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Check } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';

export function EditListingModal({ listingId, editForm, setEditForm, onClose, onSaved }) {
  const handleSave = async () => {
    try {
      await api.put(`/admin/listings/${listingId}/edit`, editForm);
      onSaved(listingId, editForm);
      toast.success('Annonce modifiee');
      onClose();
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white dark:bg-neutral-800 rounded-2xl border dark:border-neutral-700 w-full max-w-lg p-6" onClick={(e) => e.stopPropagation()} data-testid="edit-listing-modal">
        <h2 className="text-lg font-bold text-neutral-900 dark:text-white mb-4">Modifier l'annonce</h2>
        <div className="space-y-3">
          <div><Label className="text-xs text-neutral-500">Titre</Label><Input value={editForm.title || ''} onChange={(e) => setEditForm(f => ({ ...f, title: e.target.value }))} data-testid="edit-title" /></div>
          <div><Label className="text-xs text-neutral-500">Prix (€)</Label><Input type="number" value={editForm.price || 0} onChange={(e) => setEditForm(f => ({ ...f, price: parseFloat(e.target.value) || 0 }))} data-testid="edit-price" /></div>
          <div><Label className="text-xs text-neutral-500">Description</Label><textarea className="w-full rounded-md border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 px-3 py-2 text-sm min-h-[80px] resize-none focus:outline-none focus:ring-2 focus:ring-[#1F3F72] dark:text-white" value={editForm.description || ''} onChange={(e) => setEditForm(f => ({ ...f, description: e.target.value }))} data-testid="edit-description" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs text-neutral-500">Secteur</Label><Input value={editForm.sector || ''} onChange={(e) => setEditForm(f => ({ ...f, sector: e.target.value }))} /></div>
            <div><Label className="text-xs text-neutral-500">Etat</Label><Input value={editForm.condition || ''} onChange={(e) => setEditForm(f => ({ ...f, condition: e.target.value }))} /></div>
          </div>
          <div className="flex gap-2 justify-end pt-2">
            <Button variant="ghost" onClick={onClose}>Annuler</Button>
            <Button className="bg-[#1F3F72] text-white" onClick={handleSave} data-testid="save-edit-btn"><Check className="w-4 h-4 mr-1" /> Sauvegarder</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
